import script from "./QihouYj.vue?vue&type=script&setup=true&lang=js"
export * from "./QihouYj.vue?vue&type=script&setup=true&lang=js"

import "./QihouYj.vue?vue&type=style&index=0&id=3f9a2bed&lang=less&scoped=true"
script.__scopeId = "data-v-3f9a2bed"

export default script